import { Injectable } from "@angular/core";
import {
  APP_BLOB_CONFIGURATION,
  CONFIG_DEMO, CONFIG_DEMO_1, CONFIG_DEV, CONFIG_DEV1, CONFIG_DEV2, CONFIG_ECO, CONFIG_KLEARDEMO, CONFIG_LOCALHOST, CONFIG_PRE_PROD, CONFIG_PROD, CONFIG_QA,
  CONFIG_QA1,
  CONFIG_QA2,
  CONFIG_SB,
  CONFIG_SIT,
  CONFIG_STG,
  CONFIG_UAT,
  CONFIG_UATPOLICY,
  DEVELOPMENT, ENVIRONMENT, ENVIRONMENTS, PRE_PROD, PRODCOBB, PRODWSDOT, PRODUCTION, SANDBOX, SIT, SUB_DOMAIN, UAT, UATPOLICY,
  PTEST
} from "./shared/constant/constant";
import { UrlJsonConfig } from "./url-config";
import { BlobServiceClient } from "@azure/storage-blob";

@Injectable()
export class AppService {
  public urlConfig: any;
  public static CONFIG_URL: string;

  constructor(private urlJsonConfig: UrlJsonConfig) {
    AppService.CONFIG_URL = this.checkUrlDomain(this.getCurrentSubDomain());
  }

  getJson(): JSON {
    this.getUrlConfigJson().then(json => {
      this.urlConfig = json;

      const subdomain = this.getCurrentSubDomain();
      const maindomain = this.getCurrentMainDomain();
      const extension = this.getDomainExtension();
      const env = ENVIRONMENTS.find((env) => subdomain.includes(env)) || PRODUCTION;

      if (env != 'localhost') localStorage.setItem(ENVIRONMENT, env == PRODCOBB || env == PRODWSDOT ? 'prod' : env);
      else localStorage.setItem(ENVIRONMENT, DEVELOPMENT);

      if (subdomain == "kleardemo") {
        localStorage.setItem(ENVIRONMENT, CONFIG_KLEARDEMO);
      }

      if (env == UAT || env == UATPOLICY|| env == PRE_PROD) {
        // subdomain = uat-adminsure-claims.klearai.com ~ authUrl = uat-adminsure.klearai.com
        let authSubdomainArr = subdomain.split('-');
        authSubdomainArr.splice(2, 1);
        const authSubdomain = authSubdomainArr.join('-');
        this.urlConfig.AUTH_URL = `https://${authSubdomain}.${maindomain}.${extension}`;
      }
      if (env == SANDBOX || env == SIT) {
        // subdomain = sb-adminsure-claims.klearai.com ~ authUrl = sb-adminsure.klearai.com
        let authSubdomainArr = subdomain.split('-');
        authSubdomainArr.splice(2, 1);
        const authSubdomain = authSubdomainArr.join('-');
        this.urlConfig.AUTH_URL = `https://${authSubdomain}.${maindomain}.${extension}`;
      }
      if (env == PRODUCTION || env == PRODCOBB || env == PRODWSDOT) {
        // subdomain = adminsure-claims.klearai.com ~ authUrl = adminsure.klearai.com
        const authSubdomain = subdomain.split('-')[0];
        this.urlConfig.AUTH_URL = `https://${authSubdomain}.${maindomain}.${extension}`;
        // util url with client name only for prod
        this.urlConfig.DOC_URL.replace('prod', authSubdomain)
      }

      localStorage.setItem('urlConfig', JSON.stringify(this.urlConfig));
      return json;
    })
    return null;
  }

  private checkUrlDomain(subDomain: string): string {
    subDomain = subDomain.indexOf("-") !== -1 ? subDomain.split("-")[0] : subDomain;
    if (subDomain == 'dev') return CONFIG_DEV;
    if (subDomain == 'dev1') return CONFIG_DEV1;
    if (subDomain == 'dev2') return CONFIG_DEV2;
    if (subDomain == 'qa') return CONFIG_QA;
    if (subDomain == 'qa1') return CONFIG_QA1;
    if (subDomain == 'qa2') return CONFIG_QA2;
    if (subDomain.includes("localhost")) return CONFIG_LOCALHOST;
    if (subDomain.includes("demo")) {
      console.log("Environment is DEMO");
      if (subDomain.includes('demo1')) return CONFIG_DEMO_1;
      if (subDomain.includes('kleardemo')) return CONFIG_KLEARDEMO;
      return CONFIG_DEMO;
    } else if (subDomain.includes("stg")) {
      console.log("Environment is STG");
      return CONFIG_STG;
    } else if (subDomain.includes("uat")) {
      console.log("Environment is UAT");
      return CONFIG_UAT;
    } else if (subDomain.includes("uatpolicy")) {
      console.log("Environment is UATPOLICY");
      return CONFIG_UAT;
    } else if (subDomain.includes("sb")) {
      console.log("Environment is SANDBOX");
      return CONFIG_SB;
    } else if (subDomain.includes("sit")) {
      console.log("Environment is SIT");
      return CONFIG_SIT;
    } else if (subDomain.includes("preprod")) {
      console.log("Environment is PRE-PROD");
      return CONFIG_PRE_PROD;
    } else {
      console.log("Environment is PROD");
      return CONFIG_PROD;
    }
  }

  public getProductId(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.PRODUCT_ID;
  }

  public getCurrentSubDomain(): string {
    return window.location.host.split(".")[0];
    // return window.location.ancestorOrigins[0].split(".")[0];
    // return 'adminsure.klearai.com'.split('.')[0];
  }

  public getCurrentMainDomain(): string {
    return window.location.host.split(".")[1];
    // return 'adminsure-claims.klearai.com'.split('.')[0];
  }

  public getDomainExtension(): string {
    return window.location.host?.split(".")[2]?.split('/')[0];
  }

  public getEnvironmentName(subDomain: string): string {
    const env = ENVIRONMENTS.find((env) => subDomain.includes(env)) || PRODUCTION;
    return subDomain == CONFIG_KLEARDEMO ? CONFIG_KLEARDEMO : env;
  }

  public getClientName(): string {
    const subDomain = this.getCurrentSubDomain();
    const env = this.getEnvironmentName(subDomain);

    if (env == PRODUCTION)
      return subDomain.split("-")[0];
    if (env == UAT || env == UATPOLICY || env == PRE_PROD || env == SANDBOX || env == SIT)
      return subDomain.split("-")[1];
    if (env == PRODCOBB)
      return PRODCOBB;
    if (env == PRODWSDOT)
      return PRODWSDOT;
    return localStorage.getItem(SUB_DOMAIN);
  }

  public getParamsByClientNameMap(): Map<string, any> {
    const containerConfig = this.urlConfig.PARAMS_BY_CLIENT_MAP;
    const client = this.getClientName();
    const map = containerConfig[client];
    return new Map(Object.entries(map));
  }

  public setBaseUrls(urls: any) {
    this.urlConfig = urls;
  }

  public getBaseUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.BASE_URL;
  }

  public getTokenUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.TOKEN_API_URL;
  }


  

    getConfig(): any {
     const hostname = window.location.hostname;
    const env = this.checkUrlDomain(hostname);
    return this.urlJsonConfig.urlConfig[env];
  }

  getParentAppUrl(): string {
    return this.getConfig().AUTH_URL;
  }


  public getAuthUrl(): string {
    if (!this.urlConfig) {
      const configStr = localStorage.getItem('urlConfig');
      if (!configStr) {
        return this.getParentAppUrl();
      }
      try {
        this.urlConfig = JSON.parse(configStr);
      } catch (e) {
        console.error('Failed to parse urlConfig from localStorage', e);
        return this.getParentAppUrl();
      }
    }
    return this.urlConfig.AUTH_URL || this.getParentAppUrl();
  }


  public getDocUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.DOC_URL;
  }

  public getJobsUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.JOB_URL;
  }

  public getLetterUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.LETTER_URL;
  }

  public getCaAuditUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.CAAUDIT_API_URL;
  }

  public getCmsIntakeUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.CMS_INTAKE_API_URL;
  }

  public getCmsKlearUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.CMS_KLEAR_API_URL;
  }

  public getDisableUrl(): string {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.URL_DISABLED;
  }

  public getAppConfigDisplayZohoDesk(): boolean {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.DISPLAY_ZOHO_DESK;
  }

  public getAppConfigDisplayUserManual(): boolean {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.DISPLAY_USER_MANUAL;
  }

  public getTimeoutTime() {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.TIMEOUT_PERIOD;
  }

  public getExtendedTime() {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.EXTENDED_PERIOD;
  }

  public getRefreshTokenTime() {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.REFRESH_TOKEN_TIME;
  }

  public getCheckRefreshTokenTime() {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.CHECK_REFRESH_TOKEN_TIME;
  }

  public getCookieExpireDays() {
    if( !this.urlConfig ) {
      this.urlConfig = JSON.parse(localStorage.getItem("urlConfig"));
    }
    return this.urlConfig.DAYS_COOKIE_EXPIRE;
  }

  getUrlConfigJson(): Promise<Object> {
    return new Promise((resolve) => {
      let appBlobConfiguration = APP_BLOB_CONFIGURATION;
      let blobSassUrl = appBlobConfiguration.blobSassUrl;
      let containerName = appBlobConfiguration.container;
      let token = appBlobConfiguration.token;

      const blobServiceClient = new BlobServiceClient(
        `${blobSassUrl}${containerName}?${token}`
      );
      let containerClient = blobServiceClient.getContainerClient('configs').getBlockBlobClient(appBlobConfiguration.configFile);

      containerClient
        .download()
        .then((res) => {
          res.blobBody.then(async (blob) => {
            let urlConfigJson = JSON.parse(await blob.text());
            const subdomain = this.getCurrentSubDomain();

            let clientName = localStorage.getItem(SUB_DOMAIN);
            let env = ENVIRONMENTS.find((env) => subdomain.includes(env)) || PRODUCTION;
            const configEnv = env == "localhost" ? 'localhost' : clientName == PTEST ? PTEST :  env;
            localStorage.setItem('urlConfig', JSON.stringify(urlConfigJson[configEnv]));
            resolve(urlConfigJson[configEnv]);
          });
        }
        );
    });
  }
}

export function startupServiceFactory(appService: AppService): Function {
  return () => appService.getJson();
}
